import React from 'react';
import { FaCheckCircle } from "react-icons/fa";
import { useSelector } from 'react-redux';
import { SubscriptionAPI } from '../../api/SubscriptionAPI';
import { isClubOwner, isClubStaff,isUser } from '../../util/UserRoles';

const PayAsYouGoItem = ({ setRefresh, product, subscriptionInfo, setMessage, startLoading, finishLoading }) => {
    const { userInfo, clubId } = useSelector((store) => store.user);
    const handlePurchase = (event) => {
        event.preventDefault();
        if (product.productId !== subscriptionInfo.productId && subscriptionInfo?.status === 'active') {
            if (typeof setMessage === 'function') {
                setMessage({ type: 'warning', content: "You can't purchase 2 plan same time" });
                setTimeout(() => {
                    setMessage({ type: '', content: '' });
                }, 4000);
            }
        }
    }

    const handlePurchasePayAsYouGo = async () => {
        const reqData = {
            userId: userInfo.userId,
            clubId: clubId,
            planId: product?.planId,
            isSubForPlatform: false
        }
        try {
            startLoading("loading1");
            const response = await SubscriptionAPI.postPurchasePlan(reqData);
            setMessage({ type: 'success', content: "Subscription purchase successfully" });
            setTimeout(() => {
                setRefresh(true);
                finishLoading("loading1");
            }, 1000);
        } catch (error) {
            setMessage({ type: 'error', content: 'Please contact customer support' });
            finishLoading("loading1");
        }
    }
    const handleCancelPayAsYouGo = async () => {
        const reqData = {
            userId: userInfo.userId,
        }
        try {
            startLoading("loading1");
            const response = await SubscriptionAPI.postCancelPayAsYouGoPlan(reqData);
            setMessage({ type: 'success', content: response.Data });
            setTimeout(() => {
                setRefresh(true);
                finishLoading("loading1");
            }, 1000);
        } catch (error) {
            setMessage({ type: 'error', content: 'Please contact customer support' });
            finishLoading("loading1");
        }
    }

    
    if (isUser(userInfo) && subscriptionInfo?.planName !== product.planName && !product?.visible) {
        return (<></>)
    }

    return (
        <div data-testid="subscription_plan_conatiner" className={(subscriptionInfo?.status === 'active' && subscriptionInfo.planName === 'pay-as-you-go')
            ?
            "subscription_plan_conatiner active"
            :
            "subscription_plan_conatiner"
        }>
            <div className="club_plan_inner">
                <div data-testid="club_sub_active_badge" className={!isClubOwner(userInfo) && (subscriptionInfo?.status === 'active' && subscriptionInfo.planName === 'pay-as-you-go') ? "club_sub_active_badge" : "club_sub_active_badge hide"}>
                    <p>active</p>
                </div>
                <span className="club_plan_pricing">
                    <span>
                        ${Number(product?.membershipAmount) / 100}<small>/mo</small>
                    </span>
                </span>
                {product.planType === 'subscription'
                    ?
                    <p className="club_plan_title">{product?.planName}</p>
                    :
                    <p className="club_plan_title">Pay as you go</p>
                }
                <span className='club_plan_ho_line' ></span>
                <ul className="club_plan_features">
                    {product?.weekdayInfo?.map((item, index) =>
                        <li key={index}>
                            <FaCheckCircle data-testid="club_plan_icon" className="club_plan_icon" />
                            <span>Weekdays: <strong>{item.startTime} - {item.endTime}</strong>- <strong>${item.amount}/hr</strong></span>
                        </li>)}
                    {product?.weekendInfo?.map((item, index) =>
                        <li key={index}>
                            <FaCheckCircle data-testid="club_plan_icon" className="club_plan_icon" />
                            <span>Weekends: <strong>{item.startTime} - {item.endTime}</strong>- <strong>${item.amount}/hr</strong></span>
                        </li>)}
                    {product.advanceBooking != 0 &&
                        <li>
                            <FaCheckCircle data-testid="club_plan_icon" className="club_plan_icon" />
                            <span>Advance Booking: {product.advanceBooking} Days</span>
                        </li>}
                    <li>
                        <FaCheckCircle className="club_plan_icon" />
                        <span>Unlimited Reservations</span>
                    </li>
                </ul>
                {(!isClubOwner(userInfo) && !isClubStaff(userInfo)) &&
                    <div data-testid="club_plan_action1"
                        className="club_plan_action">
                        {(subscriptionInfo?.status === 'active' && subscriptionInfo.planName === 'pay-as-you-go') ?
                            <button data-testid="club_plan_button1" onClick={handleCancelPayAsYouGo} className="club_plan_button_sub_cancel">
                                Cancel
                            </button>
                            :
                            <button data-testid="club_plan_button1"
                                onClick={
                                    (subscriptionInfo?.status === 'active')
                                        ?
                                        handlePurchase
                                        :
                                        handlePurchasePayAsYouGo
                                } className="club_plan_button">
                                Purchase
                            </button>}
                    </div>}
            </div>
        </div>
    )
}
export default PayAsYouGoItem